// @ts-nocheck
import { createAsyncActionTypes } from '../../../core/store/actionCreators';

export const FETCH_CAMPAIGNS = 'campaign/fetchCampaigns';
export const {
  pending: FETCH_CAMPAIGNS_PENDING,
  fulfilled: FETCH_CAMPAIGNS_FULFILLED,
  rejected: FETCH_CAMPAIGNS_REJECTED,
} = createAsyncActionTypes(FETCH_CAMPAIGNS);

export const FETCH_CAMPAIGN = 'campaign/fetchCampaign';
export const {
  pending: FETCH_CAMPAIGN_PENDING,
  fulfilled: FETCH_CAMPAIGN_FULFILLED,
  rejected: FETCH_CAMPAIGN_REJECTED,
} = createAsyncActionTypes(FETCH_CAMPAIGN);

export const FETCH_CAMPAIGN_SERIES = 'campaign/fetchCampaignSeries';
export const {
  pending: FETCH_CAMPAIGN_SERIES_PENDING,
  fulfilled: FETCH_CAMPAIGN_SERIES_FULFILLED,
  rejected: FETCH_CAMPAIGN_SERIES_REJECTED,
} = createAsyncActionTypes(FETCH_CAMPAIGN_SERIES);

export const FETCH_CAMPAIGN_PRODUCTS = 'campaign/fetchCampaignProducts';
export const {
  pending: FETCH_CAMPAIGN_PRODUCTS_PENDING,
  fulfilled: FETCH_CAMPAIGN_PRODUCTS_FULFILLED,
  rejected: FETCH_CAMPAIGN_PRODUCTS_REJECTED,
} = createAsyncActionTypes(FETCH_CAMPAIGN_PRODUCTS);

export const CLOSE_CAMPAIGN = 'campaign/closeCampaign';
export const {
  pending: CLOSE_CAMPAIGN_PENDING,
  fulfilled: CLOSE_CAMPAIGN_FULFILLED,
  rejected: CLOSE_CAMPAIGN_REJECTED,
} = createAsyncActionTypes(CLOSE_CAMPAIGN);

export const CREATE_CAMPAIGN = 'campaign/createCampaign';
export const {
  pending: CREATE_CAMPAIGN_PENDING,
  fulfilled: CREATE_CAMPAIGN_FULFILLED,
  rejected: CREATE_CAMPAIGN_REJECTED,
} = createAsyncActionTypes(CREATE_CAMPAIGN);

export const UPDATE_CAMPAIGN = 'campaign/updateCampaign';
export const {
  pending: UPDATE_CAMPAIGN_PENDING,
  fulfilled: UPDATE_CAMPAIGN_FULFILLED,
  rejected: UPDATE_CAMPAIGN_REJECTED,
} = createAsyncActionTypes(UPDATE_CAMPAIGN);

export const CREATE_CAMPAIGN_SERIES = 'campaign/createCampaignSeries';
export const {
  pending: CREATE_CAMPAIGN_SERIES_PENDING,
  fulfilled: CREATE_CAMPAIGN_SERIES_FULFILLED,
  rejected: CREATE_CAMPAIGN_SERIES_REJECTED,
} = createAsyncActionTypes(CREATE_CAMPAIGN_SERIES);

export const UPDATE_CAMPAIGN_SERIES = 'campaign/updateCampaignSeries';
export const {
  pending: UPDATE_CAMPAIGN_SERIES_PENDING,
  fulfilled: UPDATE_CAMPAIGN_SERIES_FULFILLED,
  rejected: UPDATE_CAMPAIGN_SERIES_REJECTED,
} = createAsyncActionTypes(UPDATE_CAMPAIGN_SERIES);

export const FETCH_CAMPAIGN_SERIES_SEGMENTS = 'campaign/fetchSeriesSegments';
export const {
  pending: FETCH_CAMPAIGN_SERIES_SEGMENTS_PENDING,
  fulfilled: FETCH_CAMPAIGN_SERIES_SEGMENTS_FULFILLED,
  rejected: FETCH_CAMPAIGN_SERIES_SEGMENTS_REJECTED,
} = createAsyncActionTypes(FETCH_CAMPAIGN_SERIES_SEGMENTS);

export const UPDATE_CURRENT_PAGE = 'campaign/updateCurrentPage';
export const {
  pending: UPDATE_CURRENT_PAGE_PENDING,
  fulfilled: UPDATE_CURRENT_PAGE_FULFILLED,
  rejected: UPDATE_CURRENT_PAGE_REJECTED,
} = createAsyncActionTypes(UPDATE_CURRENT_PAGE);
